import Util from '../utils/utils';
import {SHA256} from "crypto-js";

const openAppZalo = (bindingInfo) => {
    let source = ""
    let {REACT_APP_MOBILE_ZALO_ONLY} = window.runtime_configs;
    if (!REACT_APP_MOBILE_ZALO_ONLY) {
        REACT_APP_MOBILE_ZALO_ONLY = []
    }
    if (REACT_APP_MOBILE_ZALO_ONLY.includes(bindingInfo.app_id)) {
        source = "outapp";
    }
    let bindingencoded = {
        "appid": bindingInfo.app_id,
        "token": bindingInfo.binding_token,
        "redirecturl": bindingInfo.redirect_url ? bindingInfo.redirect_url : "",
        "browser": Util.getBrowserName(),
        "source": source,
    }
    console.log(bindingInfo);
    let payload = new Buffer(JSON.stringify(bindingencoded)).toString('base64');
    let deeplink_url;
    const zpiDeeplink = window.runtime_configs.REACT_APP_ZPI_DEEPLINK;
    if (window.runtime_configs.REACT_APP_IS_PROD === '1') {
        deeplink_url = zpiDeeplink + payload; // 2.0
        if (!bindingInfo.is_legacy) {
            deeplink_url = window.runtime_configs.REACT_APP_ZPI_DEEPLINK_V2 + bindingInfo.binding_token + `&in=1`; // 2.1
        }
    } else {
        let deeplinkParam = encodeURIComponent(window.runtime_configs.REACT_APP_AGREEMENT_AUTHORIZE_URL +
            bindingInfo.binding_token);
        if (bindingInfo.is_legacy) {
            deeplinkParam = encodeURIComponent(window.runtime_configs.REACT_APP_ZPI_DOMAIN + payload);
        }
        deeplink_url = zpiDeeplink + deeplinkParam
    }
    console.log({deeplink_url});
    window.location.href = deeplink_url;
}

const openZMP = (bindingInfo, redirect_url) => {
    let source = ""
    let {REACT_APP_MOBILE_ZALO_ONLY, REACT_APP_ZMP_DEEPLINK_IOS, REACT_APP_ZMP_DEEPLINK_ANDROID} = window.runtime_configs;
    if (!REACT_APP_MOBILE_ZALO_ONLY) {
        REACT_APP_MOBILE_ZALO_ONLY = []
    }
    if (REACT_APP_MOBILE_ZALO_ONLY.includes(bindingInfo.app_id)) {
        source = "outapp";
    }
    console.log(bindingInfo);
    let deeplink_url;
    let zmpDeeplink = REACT_APP_ZMP_DEEPLINK_IOS;
    if (Util.getMobileOS() === "Android") {
        zmpDeeplink = REACT_APP_ZMP_DEEPLINK_ANDROID;
    }
    let zmpURL = new URL(zmpDeeplink);
    zmpURL.searchParams.append('b', bindingInfo.binding_token);
    zmpURL.searchParams.append('s', source);
    zmpURL.searchParams.append('from', 'mp');
    if (redirect_url) {
        zmpURL.searchParams.append('redirect_url', redirect_url);
    }
    deeplink_url = zmpURL.href;
    console.log({deeplink_url});
    window.location.replace(deeplink_url);
}

const openDeeplink = (bindingInfo, redirecturl, source = "") => {
    console.log(bindingInfo)
    let s = "webmobile";
    if (source && source !== "") {
        s = source;
    }
    let deeplinkURL = `${window.runtime_configs.REACT_APP_AGREEMENT_ZPA_DEEPLINK_V2}`;
    if (bindingInfo.is_legacy) {
        deeplinkURL = `${window.runtime_configs.REACT_APP_AGREEMENT_ZPA_DEEPLINK}`;
    }
    deeplinkURL = deeplinkURL + bindingInfo.binding_token + "&appid=" + bindingInfo.app_id + `&s=${s}`;
    deeplinkURL = redirecturl ? deeplinkURL + "&redirect_url=" + redirecturl : deeplinkURL;
    console.log('deeplinkURL', deeplinkURL);
    console.log('redirecturl', redirecturl);
    window.location.href = deeplinkURL;
}

const openUniversalLink = (bindingInfo, redirecturl, source = "") => {
    console.log(bindingInfo)
    let s = "webmobile";
    if (source && source !== "") {
        s = source;
    }
    let universalLink = `https://go.zalopay.vn/f/app?appid=731&view=authorize&b=`;

    universalLink = universalLink + bindingInfo.binding_token + `&s=${s}`;
    universalLink = redirecturl ? universalLink + "&redirect_url=" + redirecturl : universalLink;

    window.location.href = universalLink;
}

const openH5Binding = (bindingInfo) => {
    let {environment} = window.runtime_configs;
    const source = isOpenOutApp(bindingInfo.app_id) ? "outapp" : ""
    const urlRedirect = getH5BindingLink(bindingInfo.app_id, bindingInfo.binding_token, source, environment);
    console.log('[Common-function], urlRedirect', urlRedirect);
    window.location.href = urlRedirect;
}

const openZPIByDeepLink = (bindingInfo) => {
    let {REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_ANDROID,REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_IOS} = window.runtime_configs;
    const source = isOpenOutApp(bindingInfo.app_id) ? "outapp" : ""
    let bindingencoded = {
        "appid": bindingInfo.app_id,
        "token": bindingInfo.binding_token,
        "redirecturl": bindingInfo.redirect_url ? bindingInfo.redirect_url : "",
        "browser": Util.getBrowserName(),
        "source": source,
    }

    let payload = new Buffer(JSON.stringify(bindingencoded)).toString('base64');
    let deeplink_url = "";
    const zpiDeeplink = window.runtime_configs.REACT_APP_ZPI_DEEPLINK;

    deeplink_url = zpiDeeplink + payload; // 2.0
    let deepLinkZalo = REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_ANDROID;
    if(Util.getMobileOS() === "iOS"){
        deepLinkZalo = REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_IOS;
    }
    deeplink_url = deepLinkZalo + bindingInfo.binding_token + `&in=1`; // 2.1
    console.log('[openZPIByDeepLink] deeplink_url',{deeplink_url});
    window.location.href = deeplink_url;
}

const redirectH5Binding = (bindingInfo) => {
    let {environment,REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_ANDROID,REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_IOS} = window.runtime_configs;
    const source = isOpenOutApp(bindingInfo.app_id) ? "outapp" : ""
    let bindingencoded = {
        "appid": bindingInfo.app_id,
        "token": bindingInfo.binding_token,
        "redirecturl": bindingInfo.redirect_url ? bindingInfo.redirect_url : "",
        "browser": Util.getBrowserName(),
        "source": source,
    }

    let payload = new Buffer(JSON.stringify(bindingencoded)).toString('base64');
    let deeplink_url = "";
    const zpiDeeplink = window.runtime_configs.REACT_APP_ZPI_DEEPLINK;

    if (window.runtime_configs.REACT_APP_IS_PROD === '1') {
        deeplink_url = zpiDeeplink + payload; // 2.0
        if (!bindingInfo.is_legacy) {
            let deepLinkZalo = REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_ANDROID;
            if(Util.getMobileOS() === "iOS"){
                deepLinkZalo = REACT_APP_AGREEMENT_OPEN_ZPI_BY_DEEPLINK_IOS;
            }
            deeplink_url = deepLinkZalo + bindingInfo.binding_token + `&in=1`; // 2.1
            console.log('[Common-function] deeplink_url',{deeplink_url});
            window.location.href = deeplink_url;
            window.setTimeout(() => {
                // Open H5
                const urlRedirect = getH5BindingLink(bindingInfo.app_id, bindingInfo.binding_token, source, environment);
                console.log('[Common-function], urlRedirect', urlRedirect);
                window.location.href = urlRedirect;
            }, 3000)
            return;
        }
    } else {
        let deeplinkParam = "";
        // let deeplinkParam = encodeURIComponent(window.runtime_configs.REACT_APP_AGREEMENT_AUTHORIZE_URL +
        //     bindingInfo.binding_token);
        deeplink_url = getH5BindingLink(bindingInfo.app_id, bindingInfo.binding_token, source,environment);
        if (bindingInfo.is_legacy) {
            deeplinkParam = encodeURIComponent(window.runtime_configs.REACT_APP_ZPI_DOMAIN + payload);
            deeplink_url = zpiDeeplink + deeplinkParam
        }
    }
    console.log('[Common-function]',{deeplink_url});
    window.location.href = deeplink_url;
}
const checkUserAgent = (elm) => {
    return navigator.userAgent.indexOf(elm) > -1
}

export function getH5BindingLink(appId, bindingToken, source, env) {
    const d = new Date();
    let ts = d.getTime();
    let h5Link = 'https://h5p.zalopay.vn/?';//real
    switch (env) {
        case 'sandbox':
            h5Link = 'https://zlpsb-h5p.zalopay.vn/?';
            break
        case 'qc':
        case 'local':
        case 'dev': // Vì anh Quận đang deploy trên QC mà thôi, chưa có trên dev.
            h5Link = 'https://zlpqc-h5p.zalopay.vn/?';
            break
        case 'stg':
        case 'staging':
            h5Link = 'https://zlpstg-h5p.zalopay.vn/?';
            break
        case 'prod':
        case 'production':
            h5Link = 'https://h5p.zalopay.vn/?';
            break
        case 'lt':
            h5Link = 'https://zlplt-h5p.zalopay.vn/?';
            break
        // case 'dev':
        //     h5Link = 'https://zlpdev-h5p.zalopay.vn/?';//dev
        //     break
    }
    let action = 'binding';
    let bindingInfo = `{"btoken":"${bindingToken}","appid":${appId},"source":"${source}"}`;
    let ckey = 'h5client0001';
    let raw = `${appId}|${bindingToken}|${action}|${ts}|${ckey}`;
    let sig = SHA256(raw);
    let queryString = `appid=${appId}&identifier=${bindingToken}&action=${action}&ts=${ts}&sig=${sig}&bdata=${encodeURIComponent(btoa(bindingInfo))}`;
    return h5Link + queryString;
}

const isOpenOutApp = (app_id) => {
    let {REACT_APP_MOBILE_ZALO_ONLY} = window.runtime_configs;
    let lstMobileZaloOnly = [];
    if (REACT_APP_MOBILE_ZALO_ONLY){
        lstMobileZaloOnly = REACT_APP_MOBILE_ZALO_ONLY;
    }
    return lstMobileZaloOnly.includes(app_id);
}

export {openAppZalo, openDeeplink, checkUserAgent, isOpenOutApp, redirectH5Binding, openZMP,openUniversalLink,openH5Binding, openZPIByDeepLink};
